import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const CHAPTERS = [
  {
    num: "01",
    title: "Precisione",
    text: "Ogni ciglia, ogni trattamento è un gesto studiato al millimetro. La perfezione non è un dettaglio: è il nostro punto di partenza.",
  },
  {
    num: "02",
    title: "Prodotti Premium",
    text: "Selezioniamo solo formule professionali e ipoallergeniche, testate per rispettare la pelle e valorizzare la tua bellezza naturale.",
  },
  {
    num: "03",
    title: "Relax Totale",
    text: "Tempo lento, luci soffuse, profumi delicati. Da Lash Queen ogni appuntamento è un piccolo rituale dedicato solo a te.",
  },
];

export default function Manifesto() {
  return (
    <section id="filosofia" data-testid="manifesto-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40">
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="mb-6 flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.4em] text-blush-500"
      >
        <span className="h-px w-10 bg-blush-500" />
        Il nostro manifesto
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
        className="max-w-2xl font-serif text-4xl leading-tight text-ink sm:text-5xl lg:text-6xl"
      >
        Tre promesse, <span className="italic text-blush-500">un solo standard:</span> l'eccellenza.
      </motion.h2>

      <div className="mt-24 space-y-20 lg:space-y-28">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`manifesto-chapter-${c.num}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: EASE }}
            className={`relative flex flex-col gap-6 lg:w-2/3 ${i % 2 === 1 ? "lg:ml-auto lg:items-end lg:text-right" : ""}`}
          >
            <span
              aria-hidden
              className={`pointer-events-none absolute -top-16 select-none font-serif text-[9rem] italic leading-none text-blush-100 lg:text-[13rem] ${i % 2 === 1 ? "right-0" : "-left-4"}`}
            >
              {c.num}
            </span>
            <h3 className="relative font-serif text-3xl italic text-ink lg:text-4xl">
              <span className="mr-3 text-sm not-italic tracking-[0.3em] text-blush-500">{c.num}.</span>
              {c.title}
            </h3>
            <p className="relative max-w-lg text-base leading-relaxed text-ink-soft">{c.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
